import { files, generalRef } from "@/fireinit.js";
import Vue from "vue";
import axios from "axios";

export default {
  loadAll: async ({ commit, rootState }) => {
    let leads = await axios.get(`${rootState.axios.API}leads`, {
      headers: {
        Authorization: `Bearer ${rootState.user.data.auth._lat}`,
      },
    });
    commit("setList", leads.data);
  },
  save: async ({ dispatch, rootState }, payload) => {
    let response = {};
    await axios.put(`${rootState.axios.API}leads`, payload, {
      headers: {
        Authorization: `Bearer ${rootState.user.data.auth._lat}`,
      },
    });
    dispatch("loadAll");
  },
  add: async ({ dispatch, rootState }, payload) => {
    await axios
      .post(`${rootState.axios.API}leads`, payload, {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      })
      .then((response) => {
        if (response.data.result == "Error") {
          Vue.notify({
            type: "error",
            duration: 2000,
            title: response.data.Message,
          });
        }
      })
      .catch((err) => {});
    dispatch("loadAll");
  },
  delete: async ({ dispatch, rootState }, payload) => {
    await axios.post(`${rootState.axios.API}leads/delete`, payload, {
      headers: {
        Authorization: `Bearer ${rootState.user.data.auth._lat}`,
      },
    });
    dispatch("loadAll");
  },
  linkSalesEnquiryToLead: async ({ dispatch, rootState }, payload) => {
    await axios.post(
      `${rootState.axios.API}leads/linkSalesEnquiryToLead`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
  },
  loadLeadFromGridData: async ({ commit, rootState }, id) => {
    let data = await axios.get(`${rootState.axios.API}leads/leadsFrom`, {
      params: {
        excludedID: id,
      },
      headers: {
        Authorization: `Bearer ${rootState.user.data.auth._lat}`,
      },
    });
    commit("setLeadFromGridData", data.data);
  },
  loadLeadForGridData: async ({ commit, rootState }, id) => {
    let data = await axios.get(`${rootState.axios.API}leads/leadsFor`, {
      params: {
        excludedID: id,
      },
      headers: {
        Authorization: `Bearer ${rootState.user.data.auth._lat}`,
      },
    });
    commit("setLeadForGridData", data.data);
  },
  createMultipleLeads: async ({ rootState }, payload) => {
    await axios.post(
      `${rootState.axios.API}leads/createMultipleLeads`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
  },
  loadIBEmailPreview: async ({ commit, rootState }, payload) => {
    let data = await axios.post(
      `${rootState.axios.API}leads/loadIBEmailPreview`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    return data.data;
  },
  sendIBEmail: async ({ commit, rootState }, payload) => {
    let data = await axios.post(
      `${rootState.axios.API}leads/sendIBEmail`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    return data.data;
  },
  loadASEmailPreview: async ({ commit, rootState }, payload) => {
    let data = await axios.post(
      `${rootState.axios.API}leads/loadASEmailPreview`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    return data.data;
  },
  sendASEmail: async ({ commit, rootState }, payload) => {
    let data = await axios.post(
      `${rootState.axios.API}leads/sendASEmail`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    return data.data;
  },
};
